// This is a starting template. Do not edit this file directly.
// Dupicate it and modify the new file as needed.

import {
  Component,
  Host,
  Prop,
  Element,
  State,
  getAssetPath,
  Method,
  h,
  Watch
} from "@stencil/core";

import { MercuryBundles, getIconPath } from "@genexus/mercury";

import { Locale } from "../../common/locale";

const CSS_BUNDLES: MercuryBundles = [
  // Use only the bundles that are needed for this component.
  "resets/box-sizing",
  "components/edit",
  "components/button",
  "components/icon",
  "utils/layout",
  "utils/form",
  "utils/typography",
  "utils/spacing",
  "chameleon/scrollbar"
];

const SYSTEM_ICON = getIconPath({
  category: "system",
  name: "folder",
  colorType: "on-primary"
});

@Component({
  tag: "gx-ide-starting-template",
  styleUrl: "starting-template.scss",
  shadow: true,
  assetsDirs: ["gx-ide-assets/starting-template"]
})
export class GxIdeStartingTemplate {
  _componentLocale: any;

  @Element() el: HTMLGxIdeStartingTemplateElement;

  #chShortcutsEl: HTMLChShortcutsElement;
  #shortcutsSrc = getAssetPath(`./gx-ide-assets/new-kb/shortcuts.json`);

  /**
   * Description of my state variable.
   */
  @State() myStateVariable: string;

  /**
   * Description of my prop variable.
   */
  @Prop() readonly firstName: string;
  @Watch("firstName")
  firstNameChanged(newValue: string[]) {
    console.log("First name changed:", newValue);
  }

  /**
   * Callback that will be invoked when the user cancels.
   */
  @Prop() readonly cancelCallback!: CancelCallback;

  /**
   * Callback that will be invoked when the user saves.
   */
  @Prop() readonly saveCallback!: SaveCallback;

  async componentWillLoad() {
    this._componentLocale = await Locale.getComponentStrings(this.el);
  }

  componentDidLoad() {
    // Here you can do any additional setup after the component has been rendered.
  }

  /**
   * Suspends or reactivates the shortcuts
   */
  @Method()
  async suspendShortcuts(suspendShortcuts: boolean) {
    if (suspendShortcuts) {
      this.#chShortcutsEl.suspend = true;
    } else {
      this.#chShortcutsEl.suspend = false;
    }
  }

  #cancelButtonClickedHandler = () => {
    this.cancelCallback();
  };

  #saveButtonClickedHandler = () => {
    this.saveCallback();
  };

  render() {
    return (
      <Host class="widget spacing-body">
        <ch-theme model={CSS_BUNDLES}></ch-theme>
        <ch-shortcuts
          src={this.#shortcutsSrc}
          ref={(el: HTMLChShortcutsElement) =>
            (this.#chShortcutsEl = el as HTMLChShortcutsElement)
          }
        ></ch-shortcuts>
        <section class="section">
          <header class="header dialog-header dialog-header-with-border">
            <div class="field field-block">
              <label class="label" htmlFor="first-name">
                {this._componentLocale.main.firstName}
              </label>
              <ch-edit class="input" id="first-name" value={this.firstName} />
            </div>
          </header>

          <div class="main">The main content here</div>

          <footer class="footer dialog-footer dialog-footer-with-border">
            <div class="buttons-spacer">
              <button
                // #cancel
                class="button-secondary"
                id="button-cancel"
                onClick={this.#cancelButtonClickedHandler}
                part="button-cancel"
              >
                {this._componentLocale.footer.btnCancel}
              </button>
              <button
                // #create
                class="button-primary button-icon-and-text"
                id="button-create"
                onClick={this.#saveButtonClickedHandler}
                part="button-create"
              >
                <ch-image class="icon-m" src={SYSTEM_ICON}></ch-image>
                {this._componentLocale.footer.btnSave}
              </button>
            </div>
          </footer>
        </section>
      </Host>
    );
  }
}

export type CancelCallback = () => Promise<void>;

export type SaveCallback = () => Promise<string>;
